import React from "react"
import { useBlocks } from "app/regions/hooks/use-blocks"
import { LiteSlateEditor } from "../../lite-slate-editor"
import { EditableImage } from "../../../header/editable/editable-image"
import { getRatio } from "../../components/column-ratio"
import { ConditionalLink } from "../../../shared/conditional-link"

const DEFAULT_IMAGE_URL =
  "https://cdn.convertkit.com/assets/layout-placeholder-v2.png"

const styles = `
  .ck-layout-block .ck-personalsignature p { margin: 4px 0 12px 0 !important; }
`

export function PersonalSignature({ block_id, properties }) {
  const { children } = useBlocks(block_id)

  const containerStyle = {
    backgroundColor: properties.backgroundColor,
    paddingTop: properties.verticalPadding,
    paddingRight: properties.horizontalPadding,
    paddingBottom: properties.verticalPadding,
    paddingLeft: properties.horizontalPadding,
    borderTopLeftRadius: properties.borderTopLeftRadius,
    borderTopRightRadius: properties.borderTopRightRadius,
    borderBottomLeftRadius: properties.borderBottomLeftRadius,
    borderBottomRightRadius: properties.borderBottomRightRadius,
    borderWidth: properties.borderWidth,
    borderColor: properties.borderColor,
    borderStyle: "solid"
  }

  return (
    <div
      className="ck-personalsignature ck-layout-block-template"
      style={containerStyle}
      bgcolor={properties.backgroundColor}
    >
      <table
        border="0"
        cellPadding="0"
        cellSpacing="0"
        width="100%"
        bgcolor={properties.backgroundColor}
      >
        <tbody>
          <tr>
            <td
              width={getRatio(properties.columnRatio, "left")}
              style={{ verticalAlign: properties.verticalAlign }}
            >
              <ConditionalLink href={properties.imageUrl}>
                <EditableImage
                  name="image"
                  src={properties.image || DEFAULT_IMAGE_URL}
                  alt={properties.alt}
                  width="100%"
                  height="auto"
                  style={{
                    maxWidth: "100%",
                    display: "block",
                    borderRadius: properties.imageRadius
                  }}
                />
              </ConditionalLink>
            </td>
            <td
              width={getRatio(properties.columnRatio, "right")}
              style={{
                paddingLeft: 20,
                verticalAlign: properties.verticalAlign
              }}
            >
              <LiteSlateEditor block_id={children[0].block_id} />
            </td>
          </tr>
        </tbody>
      </table>
      <style>{styles}</style>
    </div>
  )
}
